import React from "react";
const SvgTermsConditions = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3_12088"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="21"
      >
        <rect y="0.167969" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3_12088)">
        <path
          d="M4.14551 17.6682C3.9094 17.6682 3.71495 17.5883 3.56217 17.4286C3.4094 17.2689 3.33301 17.071 3.33301 16.8349C3.33301 16.5987 3.41287 16.4008 3.57259 16.2411C3.73231 16.0814 3.93023 16.0015 4.16634 16.0015H12.5205C12.7566 16.0015 12.9511 16.0814 13.1038 16.2411C13.2566 16.4008 13.333 16.5987 13.333 16.8349C13.333 17.071 13.2531 17.2689 13.0934 17.4286C12.9337 17.5883 12.7358 17.6682 12.4997 17.6682H4.14551ZM6.85384 12.439L4.49967 10.0849C4.18023 9.76541 4.01704 9.37305 4.01009 8.90777C4.00315 8.4425 4.1594 8.05014 4.47884 7.73069L5.08301 7.12652L9.83301 11.8349L9.22884 12.439C8.9094 12.7585 8.51356 12.9182 8.04134 12.9182C7.56912 12.9182 7.17329 12.7585 6.85384 12.439ZM13.333 8.33486L8.62467 3.58486L9.22884 2.98069C9.54829 2.66125 9.94065 2.505 10.4059 2.51194C10.8712 2.51888 11.2636 2.68208 11.583 3.00152L13.9372 5.35569C14.2566 5.67513 14.4163 6.07097 14.4163 6.54319C14.4163 7.01541 14.2566 7.41125 13.9372 7.73069L13.333 8.33486ZM16.583 16.2515L6.29134 5.95986L7.45801 4.79319L17.7705 15.1057C17.9233 15.2585 17.9962 15.4494 17.9893 15.6786C17.9823 15.9078 17.9025 16.0987 17.7497 16.2515C17.5969 16.4043 17.4025 16.4807 17.1663 16.4807C16.9302 16.4807 16.7358 16.4043 16.583 16.2515Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default SvgTermsConditions;
